import React from 'react';
import { TFunction } from 'i18next';
// eslint-disable-next-line max-len
import ContentWrapperInteractionStatus from '../../../blocks/ContentWrapper/partials/ContentWrapperInteractionStatus/ContentWrapperInteractionStatus';
import { Namespace } from '../../../../translation/namespace';
import { ContentWrapperContext } from '../../../blocks/ContentWrapper/ContentWrapperContext';

type ContentWrapperContainer = {
  uuid: string;
  elementType: string;
  contentWrapperProps?: ContentWrapperContext | null;
  t: TFunction;
};
export function ContentWrapperContainer({ uuid, elementType, contentWrapperProps, t }: ContentWrapperContainer) {
  if (uuid === contentWrapperProps?.error?.uuid) {
    return (
      <div className="content-wrapper__container">
        <ContentWrapperInteractionStatus
          message={
            contentWrapperProps?.error?.type !== 'addBlock'
              ? t(`${Namespace.ContentWrapper}:errors.${contentWrapperProps?.error?.type}.${elementType}`)
              : t(`${Namespace.ContentWrapper}:errors.${contentWrapperProps?.error?.type}`)
          }
        />
      </div>
    );
  }
  return null;
}
